import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToastService, Toast } from '../../../core/services/toast.service';

@Component({
    selector: 'app-toast',
    template: `
    <div style="position:fixed;top:16px;right:16px;z-index:9999;display:flex;flex-direction:column;gap:8px;max-width:400px">
      <div *ngFor="let toast of toasts"
           [style.background]="getBackground(toast.type)"
           [style.color]="getColor(toast.type)"
           [style.border-color]="getBorderColor(toast.type)"
           style="padding:12px 16px;border-radius:8px;font-size:14px;display:flex;align-items:center;gap:12px;box-shadow:0 4px 12px rgba(0,0,0,0.15);border-width:1px;border-style:solid;animation:slideIn 0.2s ease">
        <span style="flex:1">{{toast.message}}</span>
        <button (click)="dismiss(toast.id)" style="background:none;border:none;cursor:pointer;opacity:0.6;padding:0;font-size:18px;line-height:1" [style.color]="getColor(toast.type)">×</button>
      </div>
    </div>
  `,
    styles: [`
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
  `],
    standalone: true,
    imports: [CommonModule]
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private sub: Subscription | null = null;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.sub = this.toastService.getToasts().subscribe(toasts => {
      this.toasts = toasts;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  dismiss(id: number): void {
    this.toastService.dismiss(id);
  }

  getBackground(type: Toast['type']): string {
    const map: Record<string, string> = {
      success: '#dcfce7',
      error: '#fee2e2',
      warning: '#fef3c7',
      info: '#dbeafe'
    };
    return map[type] || '#f3f4f6';
  }

  getColor(type: Toast['type']): string {
    const map: Record<string, string> = {
      success: '#166534',
      error: '#991b1b',
      warning: '#92400e',
      info: '#1e40af'
    };
    return map[type] || '#374151';
  }

  getBorderColor(type: Toast['type']): string {
    const map: Record<string, string> = {
      success: '#bbf7d0',
      error: '#fecaca',
      warning: '#fde68a',
      info: '#bfdbfe'
    };
    return map[type] || '#e5e7eb';
  }
}
